import { Link } from 'react-router-dom';

const stripImages = [
  'https://readdy.ai/api/search-image?query=Manga%20character%20illustration%20cutout%20style%20on%20clean%20white%20background%2C%20chibi%20cute%20style%2C%20soft%20warm%20colors%2C%20Japanese%20anime%20art%2C%20simple%20clean%20design%2C%20isolated%20character%20portrait&width=200&height=280&seq=cta-strip-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Cute%20manga%20girl%20character%20chibi%20style%20illustration%2C%20pink%20hair%2C%20school%20uniform%2C%20clean%20white%20background%2C%20soft%20pastel%20colors%2C%20Japanese%20anime%20art%2C%20isolated%20portrait&width=200&height=280&seq=cta-strip-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Cool%20manga%20boy%20character%20chibi%20style%2C%20dark%20hair%2C%20casual%20outfit%2C%20clean%20white%20background%2C%20soft%20warm%20colors%2C%20Japanese%20anime%20art%2C%20isolated%20portrait&width=200&height=280&seq=cta-strip-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Cat%20ear%20manga%20girl%20chibi%20style%20illustration%2C%20cute%20expression%2C%20clean%20white%20background%2C%20soft%20pink%20and%20cream%20colors%2C%20Japanese%20anime%20art%2C%20isolated%20portrait&width=200&height=280&seq=cta-strip-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Manga%20warrior%20boy%20chibi%20style%20with%20sword%2C%20clean%20white%20background%2C%20warm%20orange%20accents%2C%20Japanese%20anime%20art%2C%20bold%20simple%20design%2C%20isolated%20portrait&width=200&height=280&seq=cta-strip-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Magical%20girl%20manga%20chibi%20style%20with%20wand%2C%20sparkle%20effects%2C%20clean%20white%20background%2C%20soft%20purple%20and%20gold%20colors%2C%20Japanese%20anime%20art%2C%20isolated%20portrait&width=200&height=280&seq=cta-strip-06&orientation=portrait',
];

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            随时随地，畅享漫画世界
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8 max-w-lg mx-auto">
            无需注册，完全免费。立即加入数百万漫画爱好者，开启你的阅读之旅。
          </p>
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            开始免费阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex justify-center flex-wrap gap-3 md:gap-5">
          {stripImages.map((url) => (
            <div
              key={url}
              className="w-16 h-20 md:w-20 md:h-28 rounded-lg overflow-hidden bg-background-200 hover:scale-110 transition-transform duration-300 cursor-pointer"
            >
              <img
                src={url}
                alt="漫画角色"
                title="漫画角色"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}